module.exports = __webpack_public_path__ + "media/images/menu/channel_2_on-b114e16512b80ab81ed527fef88b5f23.jpg";